<template>
  <div>
    <div class="content-header">
      <div class="left">
        <span class="title">本地服务版</span>
      </div>
      <div class="right">
        <Button type="primary" @click="createModal.visible = true">生成激活码</Button>

      </div>
    </div>
    <div class="tips" style="margin-bottom: 20px">
      <Icon type="md-alert" size="20" color="#2d8cf0" style="margin-right: 10px" />
      <div>
        <div>
          提示：本页安全码仅包含智能运维的安全码，在应用中心中购买成功后，系统将自动分发所购数量的安全码至此页面；
        </div>
      </div>
    </div>
    <div>
      <Table :data="data" :columns="columns" />
      <div class="t-right" style="margin-top:10px;">
        <Page @on-change="pageChange" @on-page-size-change="sizeChange" :total="total" show-elevator show-sizer
          show-total />
      </div>
    </div>
    <create :visible="createModal.visible" @onClose="onClose"></create>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import create from './create.vue'
export default {
  components: { create },
  data () {
    return {
      data: [],
      columns: [
        {
          key: 'safety_code',
          title: '安全码',
          width: 200,
          render: (h, data) => {
            return h(
              'span',
              {},
              data.row.safety_code.length < 30 ? data.row.safety_code : '-'
            )
          }
        },
        {
          key: 'create_time',
          title: '生成时间',
          width: 200,
          render: (h, data) => {
            return h('span', {}, this.$moment(data.row.create_time))
          }
        },
        {
          key: 'mark',
          title: '识别号'
        },
        {
          key: 'active_code',
          title: '激活码',
          width: 220
        },
        {
          key: 'active_type',
          title: '激活码类型',
          render: (h, data) => {
            let type = {
              0: '设备端',
              1: '文件服务器（负载均衡）',
              2: '增值功能'
            }
            return h('span', {}, type[data.row.active_type])
          }
        },
        {
          key: 'note',
          title: '备注'
        }
      ],
      total: 0,
      page: {
        l: 10,
        p: 0
      },
      createModal: {
        visible: false
      }
    }
  },
  mounted () {
    this.getData()
  },
  methods: {
    ...mapActions(['GetLocalActiveCodeLIst']),
    getData () {
      this.GetLocalActiveCodeLIst(this.page).then(res => {
        this.data = res.data
        this.total = res.total
      })
    },
    sizeChange (l) {
      this.page.l = l
      this.getData()
    },
    pageChange (p) {
      this.page.p = p - 1
      this.getData()
    },
    onClose (status) {
      this.createModal.visible = false
      if (status) this.getData()
    }
  }
}
</script>

<style lang="less" scoped>
@import "./index.less";
</style>
